import { useEffect, useRef, useState } from "react"
import styles from "./SearchBar.module.css"

interface Props {
  value: string
  onChange: (value: string) => void
}

export function SearchBar({ value, onChange }: Props) {
  const [local, setLocal] = useState(value)
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined)

  useEffect(() => {
    setLocal(value)
  }, [value])

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const v = e.target.value
    setLocal(v)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => onChange(v), 300)
  }

  function handleClear() {
    clearTimeout(timer.current)
    setLocal("")
    onChange("")
  }

  return (
    <div className={styles.wrapper}>
      <span className={styles.icon}>🔍</span>
      <input
        type="search"
        className={styles.input}
        placeholder="会社名・証券コードで検索..."
        value={local}
        onChange={handleChange}
      />
      {local && (
        <button
          type="button"
          className={styles.clearBtn}
          aria-label="検索をクリア"
          onClick={handleClear}
        >
          ×
        </button>
      )}
    </div>
  )
}
